import { useState } from 'react'
import { iconByKey } from '../lib/icons'
import type { IconKey, NodeAnimationAsset } from '../content/types'
import { TransparentAnimation } from './TransparentAnimation'

interface ConstellationNodeProps {
  label: string
  icon: IconKey
  animation?: NodeAnimationAsset
  playAnimation?: boolean
  animationActive?: boolean
  active: boolean
  positionClass?: string
  onClick: () => void
}

export function ConstellationNode({ label, icon, animation, playAnimation = true, animationActive, active, positionClass = '', onClick }: ConstellationNodeProps) {
  const Icon = iconByKey[icon]
  const [animationFailed, setAnimationFailed] = useState(false)
  const [interactionActive, setInteractionActive] = useState(false)
  const showIcon = !animation || animationFailed
  const shouldAnimate = playAnimation && (animationActive ?? interactionActive)

  return (
    <button
      className={`constellation-node ${animation ? 'node-with-animation' : ''} ${positionClass} ${active ? 'active' : ''}`}
      onClick={onClick}
      onMouseEnter={() => setInteractionActive(true)}
      onMouseLeave={() => setInteractionActive(false)}
      onFocus={() => setInteractionActive(true)}
      onBlur={() => setInteractionActive(false)}
      aria-pressed={active}
    >
      {showIcon ? (
        <span className={`node-icon ${animation ? 'node-animation-fallback' : ''}`}><Icon aria-hidden="true" /></span>
      ) : (
        <span className="node-animation">
          <TransparentAnimation asset={animation} animate={shouldAnimate} onError={() => setAnimationFailed(true)} />
        </span>
      )}
      <span className="node-label">{label}</span>
    </button>
  )
}
